import { render, staticRenderFns } from "./HeaderWrapper.vue?vue&type=template&id=b1bb4470&scoped=true&"
import script from "./HeaderWrapper.vue?vue&type=script&lang=js&"
export * from "./HeaderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./HeaderWrapper.vue?vue&type=style&index=0&id=b1bb4470&scoped=true&lang=less&"
import style1 from "./HeaderWrapper.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bb4470",
  null
  
)

export default component.exports